// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserAccountOverview_wrapper__1Vm0D","error":"UserAccountOverview_error__3OBRS","form":"UserAccountOverview_form__1PLoW"};